<template lang="pug">
login-qr-code.rq-login(
  ref='template',
  :userRole='userRole',
  :moveLinkEvent='moveLinkEvent',
  :errorMessages='errorMessages',
  @read-qr-code='readQrCode'
)
  template(#loginTitle) 塾管理者ログイン
  template(#cameraTitle) カメラに二次元コードをかざしてください
  template(#cameraLoadingText) Loading video...
  template(#startCameraText) 二次元コードでログインする
  template(#moveLinkText) 二次元コードが読み取れない場合はこちら
</template>

<script lang="ts">
import { Component, Mixins, Ref } from 'vue-property-decorator'
import LoginMethods from '@/mixins/LoginMethods'
import LoginQrCode from '@/components/templates/manager/LoginQrCode.vue'
import { UserRoles } from '@/const/UserRoles'

/**
 * 塾管理者・二次元コードログイン画面
 */
@Component({
  components: {
    LoginQrCode,
  },
})
export default class QrLogin extends Mixins(LoginMethods) {
  // テンプレートRef
  @Ref() template!: LoginQrCode

  // 塾管理者権限
  private userRole: UserRoles = UserRoles.ACADEMY

  // QRコード読み取り時の処理
  private async readQrCode(qrCodeData: string) {
    this.$loading.start()
    const isLoginSuccess = await this.academyQrLogin(qrCodeData)
    this.$loading.complete()
    // ログイン失敗時、QRコード読み込みカメラ再起動
    if (!isLoginSuccess) setTimeout(() => this.template.startMediaDevice(), 2000)
  }

  /**
   * ログイン後の遷移先ページをオーバーライド
   */
  public topPagePath(): string {
    return '/academy/study-management'
  }

  // 遷移リンク押下時のイベント
  private moveLinkEvent() {
    // 通常ログイン画面へ遷移
    this.$router.push({ name: 'AcademyLogin' })
  }
}
</script>
